import 'bootstrap-select';
import {Litepicker} from 'litepicker';
import {proceedSuccessNotice} from './notifier';
import {syncRowFollowup} from './candidate_row_sync';
import {showToast} from './utils/toast';

function autoSaveScheduleForm(el: Element): void {
  const form = el.closest('form');
  form?.querySelector<HTMLElement>('.submit-schedule')?.click();
}

// Subtle transient "Auto-saved" toast (replaces the verbose flash for auto-saved forms).
function showAutoSaveToast(): void {
  showToast('Auto-saved');
}

const FU_FORM = '[data-followup-form]';

export function initScheduleDate(): void {

  document.querySelectorAll<HTMLInputElement>(`${FU_FORM} .schedule-date`).forEach((input) => {
    if (input.dataset.litepickerBound === '1') return;
    input.dataset.litepickerBound = '1';
    const now = new Date();
    const picker = new Litepicker({
      element: input,
      singleMode: true,
      minDate: now,
      format: 'YYYY-MM-DD',
      autoApply: true,
      // month + year dropdowns (mirrors the stats range picker in litepicker.ts)
      dropdowns: {
        minYear: now.getFullYear(),
        maxYear: now.getFullYear() + 5,
        months: true,
        years: true,
      },
    });
    // auto-save as soon as a date is picked
    picker.on('selected', () => autoSaveScheduleForm(input));
  });

  // auto-save contacted subject / body edits
  const subjectSel = `${FU_FORM} input[name="email_chain[follow_up_subject]"]`;
  $(document)
    .off('change.fuAutosave', subjectSel)
    .on('change.fuAutosave', subjectSel, function () {
      autoSaveScheduleForm(this);
    });
  $(document)
    .off('blur.fuAutosave', `${FU_FORM} .note-editable`)
    .on('blur.fuAutosave', `${FU_FORM} .note-editable`, function () {
      autoSaveScheduleForm(this);
    });

  $('.schedule-date').not(`${FU_FORM} .schedule-date`).datepicker({
    format: "yyyy-mm-dd",
    clearBtn: true,
    autoclose: true,
    startDate: new Date(),
    todayHighlight: true
  })

  $(document).off("ajax:success", ".schedule-contact").on("ajax:success", ".schedule-contact", function (event) {
    let emaiChainId = event.target.id.replace("edit_email_chain_", "")
    let $toggledEle = $(".schedule-" + emaiChainId);
    let $btnEle = $(".schedule-button-" + emaiChainId);
    let selectedDate = $toggledEle.find(".schedule-date").val() as string;

    if ($btnEle.hasClass('fu-btn')) {
      const body = $toggledEle.find('[name="email_chain[follow_up_body]"]').val() as string;
      syncRowFollowup(emaiChainId, selectedDate || null, Boolean(body && body.trim()));
      showAutoSaveToast();
      return;
    }

    $toggledEle.hide()
    if ($toggledEle.parent().parent().hasClass('all-candidates-schedule-form')) {
      $toggledEle.parent().hide()
    }
    if(selectedDate) {
      $btnEle.removeClass('active').addClass('created');
      $btnEle.attr('title', `Follow-up scheduled for ${selectedDate}`);
    } else {
      $btnEle.removeClass('active').removeClass('created');
      $btnEle.attr('title', "Schedule follow-up");
    }
    proceedSuccessNotice(event.detail[0]);
  });

  // Initialize AI draft button handlers
  initAiDraftButtons();
}

function initAiDraftButtons(): void {
  $(document).off('click', '.ai-draft-button');

  $(document).on('click', '.ai-draft-button', function() {
    const emailChainId = $(this).data('email-chain-id');
    const button = this;

    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...';

    $.ajax({
      url: `/email_chains/${emailChainId}/generate_ai_draft`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(data) {
        const form = button.closest('form');
        if (!form) return;

        const subjectInput = form.querySelector('input[name="email_chain[follow_up_subject]"]');
        const bodyEditor = form.querySelector('.summernote');

        if (subjectInput) {
          (subjectInput as HTMLInputElement).value = data.subject;
        }

        if (bodyEditor) {
          if ($.fn.summernote) {
            $(bodyEditor).summernote('code', data.body);
          } else {
            (bodyEditor as HTMLInputElement).value = data.body;
          }
        }
      },
      error: function(xhr: any) {
        let errorMessage = 'Failed to generate AI response. Please try again.';
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = 'Error generating AI response: ' + xhr.responseJSON.error;
        }
        alert(errorMessage);
      },
      complete: function() {
        button.disabled = false;
        button.innerHTML = '<i class="fas fa-robot"></i> AI Draft Response';
      }
    });
  });
}
